import { createContext } from 'react';

export interface HAccordionContextValue {
  showOnMouseLeave?: boolean,
  total: number,
  openBlockPosition: number,
  blockHeight: string,
  updateOpenBlockPosition: (current: number) => VoidFunction,
  isMobile: boolean,
}

const HAccordionContext = createContext<HAccordionContextValue>({
  showOnMouseLeave: false,
  total: 0,
  openBlockPosition: undefined,
  blockHeight: '',
  updateOpenBlockPosition: () => () => {},
  isMobile: true,
});

export default HAccordionContext;
